<template>
  <button class="accept-button" v-b-tooltip.hover title="Mark as Accepted">
    <i class="fa fa-check accept-icon"></i>
  </button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.accept-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(86, 100, 210) !important;
}
.accept-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.accept-button:hover .accept-icon {
  transform: scale(1.3);
}
.accept-button:hover {
  background-color: rgba(86, 100, 210, 0.1);
}
</style>
